import { urlForImage } from "@/js/sanity/image";
export default {
  name: "PostSection4",
  components: {},
  methods: {
    urlForImage: urlForImage
  },
  props: {
    sectionData: {
      type: Object,
      required: true
    }
  }
};